import $ from 'jquery';

export function trackEvent({ action, label = '' }) {
  const trackingCategoryName = 'Filter Builder';

  $.trackEvent(trackingCategoryName, action, label, undefined, true);
}

export function trackFiltersChangeEvent(filters) {
  Object.entries(filters)
    .forEach(([filterName, filterData]) => {
      const [{ columnName, comparator, value }] = filterData;
      const isSliderFilter = filterName.endsWith('Min') || filterName.endsWith('Max');
      let label = `${columnName}|${comparator}|${value}`;

      if (isSliderFilter) {
        label = getProperLabelName(filters, filterName);
      }

      if (label) {
        trackEvent({ action: 'Submit', label });
      }
    });
}

function getProperLabelName(filters, filterName) {
  let label = null;

  if (filterName.endsWith('Min')) {
    const sliderFilterName = filterName.replace('Min', '');
    const [min] = filters[`${sliderFilterName}Min`];
    const [max] = filters[`${sliderFilterName}Max`];

    label = `${min.columnName}|range|${min.value},${max.value}`;
  } 

  return label;
}


// WEBPACK FOOTER //
// ./src/utils/TrackEventManager.js